import { strict } from 'assert';

// EVALUACION
    export class ResponseEvaluacionModel{
        payload:EvaluacionModel[];

        constructor(){
            this.payload = new Array<EvaluacionModel>();
        }
    }

    export class ResponseResumenEvaluacionModel{
        payload: ResumenEvaluacionModel;

        constructor(){
            this.payload = new ResumenEvaluacionModel();
        }
    }

    export class ResumenEvaluacionModel{
        correctas: number;
        porcentaje:number;
        numeroIntento:number;
        evaluacion:EvaluacionModel[];
        intentos: ResumenIntentosModel[];

        constructor(){
            this.correctas = 0;
            this.porcentaje = 0;
            this.numeroIntento = 0;
            this.evaluacion = new Array<EvaluacionModel>();
            this.intentos = new Array<ResumenIntentosModel>();
        }

    }

    export class EvaluacionModel{
        idPregunta: number;
        pregunta: string;
        imagen: string;
        alternativas: AlternadivaModel[];
        correcta:boolean
        constructor(){
            this.idPregunta = 0;
            this.pregunta = '';
            this.imagen = '';
            this.correcta=false;
            this.alternativas = new Array<AlternadivaModel>();
        }

    }

    export class AlternadivaModel{
        idAlternativa: number;
        seleccionada: boolean;
        mensaje:string;
        orden:number;
        correcta:boolean;

        constructor(){
            this.idAlternativa = 0;
            this.seleccionada= false;
            this.mensaje= '';
            this.orden=0;
            this.correcta=false;
        }

    }



// MEDIOS DE VERIFICACION
    export class ResponseMedioVerificacionModel{
        payload:MedioVerificacionModel[];

        constructor(){
            this.payload = new Array<MedioVerificacionModel>();
        }
    }

    export class MedioVerificacionModel{
        idMedioVerificacion: number;
        usuario: UsuarioModel;
        periodo: PeriodoModel;
        idCarga: number;
        nombreArchivo: string;
        rutaArchivo: string;
        extension: string;
        contentType: string;
        fecha: Date;
        constructor(){
            this.idMedioVerificacion=0;
            this.usuario= new UsuarioModel();
            this.periodo= new PeriodoModel();
            this.idCarga=0;
            this.nombreArchivo='';
            this.rutaArchivo='';
            this.extension='';
            this.contentType='';
            this.fecha=null;
        }
    }

    export class MedioVerificacionAsociarModel{
        idMedioVerificacion: number;
        usuario: UsuarioModel;
        periodo: PeriodoModel;
        idCarga: number;
        nombreArchivo: string;
        rutaArchivo: string;
        extension: string;
        contentType: string;
        fecha: Date;
        selected: boolean;
        comentario:string;
        disabled:boolean;
        constructor(){
            this.idMedioVerificacion=0;
            this.usuario= new UsuarioModel();
            this.periodo= new PeriodoModel();
            this.idCarga=0;
            this.nombreArchivo='';
            this.rutaArchivo='';
            this.extension='';
            this.contentType='';
            this.fecha=null;
            this.selected = false;
            this.comentario='';
            this.disabled= false;
        }

    }

    export class UsuarioModel{
        idUsuario: number;
        usuario: string;
        password: string;
        tipoUsuario: TipoUsuarioModel;

        constructor(){
            this.idUsuario = 0;
            this.usuario = '';
            this.password = '';
            this.tipoUsuario = new TipoUsuarioModel();
        }
    }

    export class TipoUsuarioModel{
        idTablaMaestra: number;
        discriminador: number;
        descripcionCorta: string;
        descripcionLarga: string;
        agrupador: number;

        constructor(){
            this.idTablaMaestra = 0;
            this.discriminador = 0;
            this.descripcionCorta = '';
            this.descripcionLarga = '';
            this.agrupador = 0;
        }
    }

    export class PeriodoModel{
        idPeriodo: number;
        anio: number;
        activo: number;

        constructor(){
            this.idPeriodo = 0;
            this.anio = 0;
            this.activo = 0;
        }
    }

    export class ResponseResumenIntentosModel{
        payload:ResumenIntentosModel[];

        constructor(){
            this.payload = new Array<ResumenIntentosModel>();
        }
    }

    export class ResumenIntentosModel{
        intento: number;
        correctas: number;
        cantidad: number;
        porcentaje: number
        estado: string;

        constructor(){
            this.intento = 0;
            this.correctas = 0;
            this.cantidad = 0;
            this.porcentaje = 0;
            this.estado = '';
        }
    }

// AUTOEVALUACION
    export class ResponseAutoevaluacionModel{
        payload:AutoevaluacionModel[];

        constructor(){
            this.payload = new Array<AutoevaluacionModel>();
        }
    }

    export class AutoevaluacionModel{
        idArea: number;
        orden: number;
        nombre: string;
        area: string;
        finalizado: number;
        dimensiones: DimensionModel[];

        constructor(){
            this.idArea = 0;
            this.orden = 0;
            this.nombre = '';
            this.area = '';
            this.finalizado = 0;
            this.dimensiones = new Array<DimensionModel>();
        }
    }
    
    export class DimensionModel{
        idDimension: number;
        orden: number;
        nombreCorto: string;
        dimension: string;
        descripcion: string;
        ponderacion: number;
        finalizado: number;
        elementos:ElementoModel[];

        constructor(){
            this.idDimension = 0;
            this.orden = 0;
            this.nombreCorto = '';
            this.dimension = '';
            this.descripcion = '';
            this.ponderacion = 0;
            this.finalizado = 0;
            this.elementos = new Array<ElementoModel>();
        }
    }

    export class ElementoModel{
        idElementoGestion: number;
        orden: number;
        nombreCorto: string;
        elementoGestion: string;
        indicador: string;
        finalizado: boolean;
        retroAlimentacion: RetroAlimentacionModel[];
        vinculados: VinculadoModel[];

        constructor(){
            this.idElementoGestion = 0;
            this.orden = 0;
            this.nombreCorto = ''
            this.elementoGestion = '';
            this.indicador = '';
            this.finalizado = false;
            this.retroAlimentacion = new Array<RetroAlimentacionModel>();
            this.vinculados = new Array<VinculadoModel>();
        }
    }

    export class RetroAlimentacionModel{
        idRetroAlimentacion: number;
        retroAlimentacion: string;
        nota: number;
        seleccionada: boolean;
        constructor(){
            this.idRetroAlimentacion = 0;
            this.retroAlimentacion = '';
            this.nota = 0;
            this.seleccionada = false;
        }
    }

    export class VinculadoModel{
        comentario: string;
        idMedioVerificacionElementoGestion: number;
        nombre: string;
        idMedioVerificacion : number
        constructor(){
            this.comentario = '';
            this.idMedioVerificacionElementoGestion = 0;
            this.nombre = '';
            this.idMedioVerificacion = 0;
        }
    }
